import { createContext, MiddlewareFunction, replace } from 'react-router';
import { settingsContext } from '~/app/settingsMiddleware';
import { AppState } from '~/stores/app';
import { REFERRER_QUERY_PARAM } from '~/utils/constants';
import { appStoreContext } from '~/utils/routing';

export type Registrations = AppState['registrations'];
export const registrationContext = createContext<Registrations>();

export const registrationMiddleware: MiddlewareFunction = ({
  params,
  context,
  request,
}) => {
  const settings = context.get(settingsContext);

  if (!settings.registrations.isEnabled) {
    throw replace(`/${params.store ?? ''}`);
  }

  const appStore = context.get(appStoreContext);
  let state = appStore.getState();

  const referrer = new URL(request.url).searchParams.get(REFERRER_QUERY_PARAM);

  if (referrer && state.registrations.referrer !== referrer) {
    appStore.dispatch(appStore.actions.registrations.setReferrer(referrer));
    state = appStore.getState();
  }

  context.set(registrationContext, state.registrations);
};
